export default __webpack_public_path__ + "static/media/no-arhiv-offers.b950ac40.svg";